import validate from "/opt/render/project/src/node_modules/.pnpm/nuxt@4.1.3_@netlify+blobs@9.1.1_@parcel+watcher@2.5.1_@types+node@22.15.21_@vue+compile_f6c70ea1eb533eaec0fe8a1184c3379f/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/render/project/src/node_modules/.pnpm/nuxt@4.1.3_@netlify+blobs@9.1.1_@parcel+watcher@2.5.1_@types+node@22.15.21_@vue+compile_f6c70ea1eb533eaec0fe8a1184c3379f/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}